export default {
  'user.details.profile': 'Profile',
  'user.details.copy': 'Copy',
  'user.details.copy.success': 'Copied successfully',
  'user.details.loadFailed': 'Failed to load user information',

  'user.details.account': 'Account',
  'user.details.memberId': 'User ID',
  'user.details.email': 'Email',
  'user.details.registerType': 'Register Type',
  'user.details.registerType.phone': 'Phone',
  'user.details.region': 'Region',
  'user.details.merchant': 'Merchant',

  'user.details.status': 'Account Status',
  'user.details.status.formal': 'Formal',

  'user.details.parentAgent': 'Parent Agent',
  'user.details.sameParentCount': 'Users under same agent',

  'user.details.realName': 'Real Name',
  'user.details.sameNameCount': 'Users with same name',

  'user.details.vipLevel': 'VIP Level',
  'user.details.memberLevel': 'User Level',
  'user.details.defaultLevel': 'Default Level',

  'user.details.balance': 'Balance',
  'user.details.balance.available': 'Available',
  'user.details.balance.yuebao': 'Yuebao',
  'user.details.balance.frozen': 'Frozen',

  'user.details.dpTodayTotal': 'Today/Total Deposit',
  'user.details.wdTodayTotal': 'Today/Total Withdraw',
  'user.details.validBetTodayTotal': 'Today/Total Valid Bet',
  'user.details.winlossTodayTotal': 'Today/Total Win/Loss',
  'user.details.promoTodayTotal': 'Today/Total Promotion',
  'user.details.commissionTodayTotal': 'Today/Total Commission',

  'user.details.withdrawAccount': 'Withdraw Account',
  'user.details.lastLogin': 'Last Login',
  'user.details.registerIp': 'Register IP',
  'user.details.loginType': 'Login Type',
  'user.details.registerChannel': 'Register Channel',
  'user.details.verifyMethod': 'Verification',

  'user.details.addBlacklist': 'Add to Blacklist',
  'user.details.forbidBet': 'Forbid Betting',
  'user.details.kick': 'Kick Out',
  'user.details.changePassword': 'Change Password',
  'user.details.changeFundPassword': 'Change Fund Password',
  'user.details.resetFundPassword': 'Reset Fund Password',
  'user.details.agentLine': 'Agent Line',

  'user.details.changeLevel': 'Change Level',

  'user.details.manualDp': 'Manual Deposit/Withdraw',
  'user.details.fundDetail': 'Fund Details',
  'user.details.dpRecords': 'Deposit Records',
  'user.details.wdRecords': 'Withdraw Records',
  'user.details.auditDetail': 'Audit Details',
  'user.details.betRecords': 'Bet Records',
  'user.details.winlossOverview': 'Win/Loss Overview',
  'user.details.winlossStats': 'Win/Loss Statistics',
  'user.details.promoRecords': 'Promotion Records',

  'user.details.sameIpLoginCount': 'Users login with same IP',
  'user.details.sameIpRegisterCount': 'Users registered with same IP',

  'user.details.phone': 'Phone',
  'user.details.changePhone': 'Change Phone',
  'user.details.changeEmail': 'Change Email',
  'user.details.unbindTelegram': 'Unbind Telegram',

  'common.normal': 'Normal',
  'common.refresh': 'Refresh',
  'common.unbound': 'Unbound',
  'common.remark': 'Remark',
  'common.edit': 'Edit',
};
